import { render, staticRenderFns } from "./SCRAMJobStats.vue?vue&type=template&id=40410521"
import script from "./SCRAMJobStats.vue?vue&type=script&lang=js"
export * from "./SCRAMJobStats.vue?vue&type=script&lang=js"
import style0 from "./SCRAMJobStats.vue?vue&type=style&index=0&id=40410521&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports